<script setup>
import { ref, onMounted, computed } from "vue";
import { useServiceStore } from "@/stores/serviceStore";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useRequestsStore } from "@/stores/storeRequests";
import { useRouter } from "vue-router";

const storeService = useServiceStore();
const storeRequests = useRequestsStore();
const router = useRouter()

const loaderActive = ref(false);
const rentalInfo = ref({});
const isSucceeded = computed(() => rentalInfo.value.transaction.status === "succeeded")
const isRefunded = computed(() => rentalInfo.value.transaction.status === "refunded")
const isCourtSelected = computed(() => Object.keys(storeService.selectedCourt).length > 0);
const totalPrice = computed(() => isCourtSelected.value ? storeService.courtTimes.reduce((acc, item) => acc + item.price, 0) : storeService.courtTimes[0]?.price);

const nextSreen = async () => {
	const parametrs = {
		items: storeService.courtTimes.map(item => {
			return {
				type: item.type,
				quantity: item.quantity,
				rental_at: item.rental_at,
				crm_id: item.crm_id
			}
		})
	}
	await storeRequests.getPaymentUrl(parametrs);
	if(!storeRequests.responseOk) return;
	window.location.href = storeRequests.payData?.transaction.payment_link;
	sessionStorage.setItem('rentalId', storeRequests.payData?.id); 
}

const previousSreen = () => {
    const isGoingToInventory = !isCourtSelected.value;
    if (isGoingToInventory) {
        storeService.clearSessionCourtTimes();
    }
    storeService.goToScreen(isCourtSelected.value ? storeService.screens.selectDate : storeService.screens.rentalInventory)
    router.push({ hash: `#${isCourtSelected.value ? storeService.screens.selectDate : storeService.screens.rentalInventory}`})
}




function formatDateTimeRange(dateTimeStr) {
	
	if (!dateTimeStr) return

	const [datePart, timePartFull] = dateTimeStr.split('T')
	const [year, month, day] = datePart.split('-')
	const [hourStr, minute] = timePartFull.split(':') // ["19", "00", "00+03:00"]

	let hour = parseInt(hourStr, 10)

	const formattedDate = `${day}.${month}.${year}`

	const start = `${String(hour).padStart(2, '0')}:${minute}`

	let endHour = (hour + 1) % 24
	const end = `${String(endHour).padStart(2, '0')}:${minute}`

	return `${formattedDate} (${start} — ${end})`
}



onMounted( async() => {

	const rentalId = sessionStorage.getItem("rentalId");
	const rentalIdNum = rentalId ? Number(rentalId) : null;

	if(rentalIdNum) {
		loaderActive.value = true
		rentalInfo.value = await storeRequests.getRentalInfo(rentalIdNum);
		sessionStorage.removeItem("rentalId")
		if(isSucceeded.value) {
			storeService.goToScreen(storeService.screens.success)
			return
		}
		loaderActive.value = false
	}

	storeService.hideScreenLoader()
});

</script>

<template>
	<div class="services-container">
		<div class="container">
			<button class="services-btn-back" @click="previousSreen">
				<svg width="24" height="24"><use href="#back_icon"></use></svg>
				<span>Назад</span>
			</button>
			<h2 class="service-title">подтверждение бронирования</h2>
			<div class="service">
				<div class="bookings">
					<div class="service__slide">
						<div class="service__slide-item">
							<div class="service__slide-image" v-if="storeService.selectedCourt.image">
								<img class="full-img" width="670" height="426" :src="storeService.selectedCourt.image" alt="изображение" />
							</div>
							<div class="service__slide-footer">
								<div class="service__slide-row">
									<div class="service__slide-name" v-if="isCourtSelected">{{ storeService.selectedCourt?.title }}</div>
									<div class="service__slide-name --small" v-else>{{ storeService.courtTimes[0]?.title }}</div>
									<div class="service__slide-price" v-if="!isCourtSelected">
										<span>Стоимость:</span>
										<span>от {{  storeService.courtTimes[0]?.price }} ₽</span>
									</div>
								</div>
								<div class="service__slide-row" v-if="isCourtSelected">
									<div class="service__slide-name --small">Информация о бронировании</div>
									<div class="service__slide-price">
										<span>Услуга:</span>
										<span>{{ storeService.selectedCourt.title }}</span>
									</div>
									<div class="service__slide-price">
										<span>Дата и время:</span>
										<div class="service__slide-time" v-if="storeService.courtTimes.length">
											<div 												
												v-for="item of storeService.courtTimes" :key="item.rental_at"
											>
												<span>{{ formatDateTimeRange(item.rental_at) }} </span>
												<span> <nobr>- {{ item.price }} ₽</nobr></span>
												
											</div>											
										</div>
									</div>
								</div>
								<div class="service__slide-row --total" v-if="isCourtSelected">
									<div class="service__slide-price">
										<span>Итого:</span>
										<span>{{ totalPrice }} ₽</span>
									</div>
								</div>
								<p v-if="!totalPrice" class="form-text-error">Необходимо выбрать дату и время</p>
								<p class="form-text-error" style="margin-bottom: 10px;" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
								<div class="service__slide-row --desc-quipment" v-if="storeService.courtTimes[0]?.desc">
									<div class="service__slide-price">
										<span>Описание</span>
										<span v-html="storeService.courtTimes[0]?.desc"></span>
									</div>
								</div>
							</div>
                            <button 
								:disabled="!totalPrice"
								class="bookings__btn btn --full" 
								@click="nextSreen"
							>
								<span v-if="!storeRequests.loaderBtn">Оплатить</span>
								<img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader_black.png" alt="изображение" />
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.bookings {
	max-width: 73rem;
	margin-left: auto;
	margin-right: auto;

	.service__slide {
		width: 100%;
		height: 100%;
		opacity: 1;
	}
	.service__slide-item {
		width: 100%;
	}
	.service__slide-image {
		width: 100%;
		height: 42.6rem;
        @media (max-width: vars.$x480) {
            height: 21rem;
        }
		img {
			width: 100%;
			height: 100%;
		}
	}
	.service__slide-footer {
		display: grid;
		gap: 4rem;
        margin-bottom: 13rem;
        @media (max-width: vars.$x425) {
            gap: 1rem;
            margin-bottom: 1rem;
        }
	}
	.service__slide-row {
		display: grid;
		gap: 1rem;
		padding-bottom: 3rem;
        border-bottom: 1px solid var(--border-default-4);            
        @media (max-width: vars.$x425) {
            padding-bottom: 2rem;
            gap: 1.5rem;
        }
		&.--total {
            border-bottom: 0px solid var(--border-default-4);
			.service__slide-price {
				span {
					font-weight: 800;
					font-size: 3.2rem;
                    @media (max-width: vars.$x425) {
                        font-size: 2.4rem;
                    }
					&:first-child {
						font-weight: 500;
						font-size: 2.4rem;
                        @media (max-width: vars.$x425) {
                            font-size: 1.8rem;
                        }
					}
				}
			}
		}
		&.--desc-quipment {
            border-bottom: 0px solid var(--border-default-4);
			.service__slide-price {
				grid-template-columns: 1fr;
				span {
					font-weight: 500;
					font-size: 2rem;
					color: var(--text-inverse-100);
                    @media (max-width: vars.$x425) {
                        font-size: 1.6rem;
                    }
					&:first-child {
						font-weight: 500;
						font-size: 2.4rem;
                        @media (max-width: vars.$x425) {
                            font-size: 1.8rem;
                        }
					}
				}
			}
		}
	}
	.service__slide-name {
		margin-bottom: 0;
        &.--small {
            font-weight: 500;
            font-size: 2.4rem;
            @media (max-width: vars.$x425) {
                font-size: 1.8rem;
            }
        }
	}
	.service__slide-price {
		padding-bottom: 0rem;
		border-bottom: 0px solid var(--border-default-4);
		margin-bottom: 0rem;
	}
	.service__slide-time {
		display: grid;
		gap: .5rem;
		div {
			display: flex;
			gap: .5rem;
			flex-wrap: wrap;
		}
		span {
			display: block;
			font-weight: 700;
			color: var(--text-inverse-100);
		}
	}
	.service__slide-btn {
	}
}

.bookings__btn {
	
}
</style>
